import { Create, required, SimpleForm, TextInput } from 'react-admin';
import { LABELS } from 'shared/constants/labels';

export const TherapyMethodsCreate = () => {
  return (
    <Create>
      <SimpleForm>
        <TextInput
          source="name"
          label={LABELS.name}
          validate={[required()]}
          fullWidth
        />
      </SimpleForm>
    </Create>
  );
};
